import {
  FETCH_AGENTS,
  FETCH_AGENTS_SUCCESS,
  FETCH_AGENTS_FAILURE,
  FETCH_AGENT,
  FETCH_AGENT_SUCCESS,
  FETCH_AGENT_FAILURE,
  FETCH_AGENTS_BY_OBSERVATIONS,
  FETCH_AGENTS_BY_OBSERVATIONS_SUCCESS,
  FETCH_AGENTS_BY_OBSERVATIONS_FAILURE,
  CLEAR_SELECTED_AGENT,
} from '../mutation-types'

const mutations = {
  [FETCH_AGENTS] (state) {
    state.loading = true
    state.error = null
  },
  [FETCH_AGENTS_SUCCESS] (state, agents) {
    state.agents = agents
    state.loading = false
  },
  [FETCH_AGENTS_FAILURE] (state, error) {
    state.agents = []
    state.error = error
    state.loading = false
  },
  [FETCH_AGENTS_BY_OBSERVATIONS] (state, error) {
    state.loading = true
    state.error = null
  },
  [FETCH_AGENTS_BY_OBSERVATIONS_SUCCESS] (state, agents) {
    state.matchingAgents = agents
    state.loading = false
  },
  [FETCH_AGENTS_BY_OBSERVATIONS_FAILURE] (state, error) {
    state.matchingAgents = []
    state.loading = false
    state.error = error
  },
  [FETCH_AGENT] (state) {
    state.loading = true
    state.error = null
  },
  [FETCH_AGENT_SUCCESS] (state, agent) {
    state.selected = agent
    state.loading = false
  },
  [FETCH_AGENT_FAILURE] (state, error) {
    state.loading = false
    state.error = error
  },
  [CLEAR_SELECTED_AGENT] (state) {
    state.selected = null
  }
}

export default mutations
